import { Form } from 'react-bootstrap';
import { Control, Controller, RegisterOptions } from 'react-hook-form';

type DateInputProps = {
	type: 'time' | 'date' | 'week' | 'month';
	id?: string;
	name: string;
	className?: string;
	containerClass?: string;
	label?: string;
	placeholder?: string;
	helpText?: string;
	readOnly?: boolean;
	disabled?: boolean;
	errors?: any;
	control?: Control<any>;
	register?: RegisterOptions;
	value?: Date;
	onChange?: (date: Date) => void;
};

export default function DateInput({
	name,
	id,
	control,
	className,
	containerClass,
	label,
	placeholder,
	helpText,
	readOnly,
	errors,
	register,
	type,
	value,
	...props
}: DateInputProps) {
	const hasError = errors && errors[name];
	return (
		<Controller
			name={name}
			control={control}
			render={({ field, fieldState }) => (
				<Form.Group className={containerClass ?? ''}>
					{label && <Form.Label>{label}</Form.Label>}
					<Form.Control
						type={type}
						id={id}
						{...props}
						{...field}
						value={field.value ?? ''}
						onChange={(e) => {
							field.onChange(e.target.value);
						}}
						placeholder={placeholder}
						readOnly={readOnly}
						className={className}
						isInvalid={Boolean(fieldState.error?.message) || hasError}
					/>
					{helpText && (
						<Form.Text id={`${name}-help`} muted>
							{helpText}
						</Form.Text>
					)}
					{hasError && (
						<Form.Control.Feedback type="invalid">
							{typeof errors[name] === 'string' && errors[name]}
							{errors[name]?.message}
							{errors[name] &&
								Array.isArray(errors[name]) &&
								errors[name].map((message: string) => message)}
						</Form.Control.Feedback>
					)}
					{fieldState.error?.message && (
						<>
							<div className="is-invalid" />
							<Form.Control.Feedback type="invalid">
								{fieldState.error?.message}
							</Form.Control.Feedback>
						</>
					)}
				</Form.Group>
			)}
		/>
	);
}
